 
import React, { useEffect, useState, useRef } from "react";  
import {decode,encode} from 'html-entities';  
import {  __courseCardNew, renderCustomCourseCard, filterCourses, selectTimezone, renderSearchBlockOnCreate , addToCart, goToCart, buyNow } from "../../modules/studentDashboard/react_course_card";
import { useSelector } from "react-redux";

function Pageview( { page_content,asset_url_data, defaultCurrency} ) {    
  const [load_page, setLoadPageHtml]          = useState(false);
  const [elementRendered, setElementRendered] = useState(false);
  const contentRef                            = useRef();  
  const _asset_url                            = asset_url_data;
  const __site_url                            = window.location.origin;
  const enrolled                              = useSelector((state) => state.user.user.logged_in_user.enrolled);
  const currency                              = defaultCurrency;
  const renderHTML                            = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
  const shoppingCartEnabled                   = useSelector((state) => state.user.miscellaneous.shopping_cart);
  const loadCss = (html) => {   
    return <div dangerouslySetInnerHTML={createMarkup(html)} />;  
  } 

  const loadJs = () => {   
    
    
    lodaBoxCss(_asset_url+"contentboxassets/box/box.css?v=1.003_mykademy_uat1");
    lodaBoxCss(_asset_url+"contentboxassets/box/custom.css?v=1");
    lodaBoxCss(_asset_url+"contentboxassets/minimalist-blocks/content.css"); 
    // lodaBoxCss(_asset_url+"css/admin-theme.css");  

    // let script = document.createElement("script");
    // script.src = ''+_asset_url+'js/jquery.min.js?v=1.003_mykademy_uat';
    // script.async = true; 
    // document.body.appendChild(script);  


    // setTimeout(() => {
    //   let _src = [
    //     // _asset_url+'contentboxassets/custom.js?v=1.003_mykademy_uat',
    //     _asset_url+'contentboxassets/box/box.js?v=1.003_mykademy_uat',
    //             ];
      
    //   _src.forEach((_scripts, index) => {
    //       script = document.createElement("script");
    //       script.src = _scripts;
    //       script.async = true; 
    //       document.body.appendChild(script);  
    //   });

    //   setLoadPageHtml(true) 
    // }, 1);

    loadScript(''+_asset_url+'js/jquery.min.js?v=1.003_mykademy_uat')
    .then(() => { 
       loadScript( _asset_url+'contentboxassets/box/box.js?v=1.003_mykademy_uat');
       setLoadPageHtml(true) 
    });
    
  }

  function loadScript(src) { 
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.onload = resolve;
      script.onerror = reject;
      document.body.appendChild(script);
    });
  }

  function lodaBoxCss(links_url){
    let linkElement = document.createElement("link");

    linkElement.setAttribute("rel", "stylesheet");
        linkElement.setAttribute("type", "text/css");
        linkElement.setAttribute(
                          "href",
                          links_url
                        );
        document.head.appendChild(linkElement);
  }
  function __courseCardNew(){
    return '';
  }
  function createMarkup(html) {
    return {__html: html};
  }  
  function loadContent(content)
  {
    return renderHTML(decode(content, {level: 'html5'})); 
  }
  useEffect(() => { 
    setTimeout(() => {   
        if(page_content)
        {
          const fragment = document.createRange().createContextualFragment(
            ` <div class="is-wrapper cms-content-is-wrapper custompage-box custom-landing-slider">${decode(page_content?.content, {level: 'html5'})}</div>`,  
            document.querySelector(".mk-page-loader").style.display = 'none'

          ); 
          contentRef.current.appendChild(fragment);

          let customDiv = document.createElement("div");
          customDiv.setAttribute("data-custom-block","custom_course_card_block");
           
          let courseListTopClass  = document.getElementsByClassName("courseListTop");

          if(courseListTopClass.length > 0){
            courseListTopClass[0].appendChild(customDiv);
          }
          
        }
          const custom_course_card_blocks = document.querySelectorAll('[data-custom-block="custom_course_card_block"]');          
          if(custom_course_card_blocks)
          {
                custom_course_card_blocks.forEach(custom_course_card_block => {
                  const coruseCardInnerHtml = renderCustomCourseCard(enrolled, shoppingCartEnabled)
                 coruseCardInnerHtml.then((res) => {
                  custom_course_card_block.innerHTML = res;
                  setElementRendered(true);
                 }); 
                 
              });         
          } 

          const custom_search_blocks = document.querySelectorAll('[data-custom-block="custom_banner_search_block"]');
          if(custom_search_blocks)
          {
              custom_search_blocks.forEach(custom_search_block => {
                var search_id = custom_search_block.getAttribute('id');
                renderSearchBlockOnCreate(search_id);
                // console.log(search_id);
                  // custom_course_card_block.innerHTML = renderCustomCourseCard();  
              });         
          } 
         
    }, 100);

  },[load_page,filterCourses]);   
  
  const filterClickHandler = (type) => {
    filterCourses(type, enrolled);
    setElementRendered(false);
    setTimeout(() => setElementRendered(true), 300);
  };

  useEffect(() => { 

    if (elementRendered) {
        const allCourseButton = document.querySelector("#filterCourses_0");
        const blendedCourseButton = document.querySelector("#filterCourses_1");
        const offlineCourseButton = document.querySelector("#filterCourses_2");
        const upcomingCourseButton = document.querySelector("#filterCourses_3");
        const onlineCourseButton = document.querySelector("#filterCourses_4");
        const bundleButton = document.querySelector("#filterCourses_5");
        const selectTimeZone = document.querySelector("#select_time_zone");
        const addtoCartButtons = document.querySelectorAll(".add-to-cart-btn");
        const buyNowButtons   = document.querySelectorAll(".buy-now-btn");
        if (allCourseButton) {
            allCourseButton.addEventListener("click", () => filterClickHandler(0)); 
        }
        if (blendedCourseButton) {
            blendedCourseButton.addEventListener("click", () => filterClickHandler(1)); 
            }
            if (offlineCourseButton) {
              offlineCourseButton.addEventListener("click", () => filterClickHandler(2));
            }
            if (upcomingCourseButton) {
              upcomingCourseButton.addEventListener("click", () => filterClickHandler(3));
            }
            if (onlineCourseButton) {
              onlineCourseButton.addEventListener("click", () => filterClickHandler(4));
            }
            if (bundleButton) {
              bundleButton.addEventListener("click", () => filterClickHandler(5));
            }
            if (selectTimeZone) {
            selectTimeZone.addEventListener("click", () => selectTimezone(selectTimeZone, enrolled));
            }
            if (addtoCartButtons) {
              addtoCartButtons.forEach((elem) => {
                elem.addEventListener("click", () => addToCart(elem, elem.getAttribute("data-item-id"), elem.getAttribute("data-item-type")));
              });
            }

            if (buyNowButtons) {
              buyNowButtons.forEach((elem) => {
                elem.addEventListener("click", () => buyNow(elem, elem.getAttribute("data-item-id"), elem.getAttribute("data-item-type")));
              });
            }
            
              //   $('.add-to-cart-btn').on('click', function(e){
              //     addToCart($(this), $(this).data('item-id'), $(this).data('item-type'));
              // });

            //   $('.buy-now-btn').on('click', function(e){
            //     buyNow($(this), $(this).data('item-id'), $(this).data('item-type'));
            // });
        return () => {
            if (allCourseButton) {
                allCourseButton.removeEventListener("click", filterCourses);
            }
            if (blendedCourseButton) {
                blendedCourseButton.removeEventListener("click", filterCourses);
            }
            if (offlineCourseButton) {
                offlineCourseButton.removeEventListener("click", filterCourses);
            }
            if (upcomingCourseButton) {
                upcomingCourseButton.removeEventListener("click", filterCourses);
            }
            if (onlineCourseButton) {
                onlineCourseButton.removeEventListener("click", filterCourses);
            }
            if (bundleButton) {
                bundleButton.removeEventListener("click", filterCourses);
            }
            if (selectTimeZone) {
                selectTimeZone.removeEventListener("click", selectTimezone);
            }
            if (addtoCartButtons) {
              addtoCartButtons.forEach((elem) => {
                elem.removeEventListener("click", addToCart);
              });
            }
            if (buyNowButtons) {
              buyNowButtons.forEach((elem) => {
                elem.removeEventListener("click", buyNow);
              });
            }
            
        }
    }
}, [elementRendered, filterCourses]);
const search_button = document.querySelector("#searchbtn");
if(search_button)
{
  search_button.addEventListener("click", () => {
    searchBtnHandleClick();
    search_button.removeEventListener("click", search_button);

  });

}

const searchBtnHandleClick = () => {
    var val = document.querySelector('#searchid').value;
    var res = val.split(" ");
    var str = encodeURIComponent(val);
    if(val.length=="0"){
      document.querySelector("#searchid").style.border = '2px solid rgb(220, 81, 81)';

      // $("#searchid").css('border', '2px solid rgb(220, 81, 81)'); 
    }
    else{
      window.location = __site_url + '/course/listing/?search='+str;
    }
};
  return (
    <>
    <div>
        {
            (page_content?.content)?
            <div>  
                {loadCss(decode(page_content?.mainCss))} 
                {loadCss((decode(page_content?.sectionCss)))} 
                {  
                     <div ref={contentRef} />

                  // loadContent(page_content.page_content?.content)  
                } 
                {  loadJs() } 
            </div>
            :''

        }
    </div>
    </>
  );
}

export default Pageview;
